import Modal from './components/modal';

/**
 * Initializes tooltips by creating Modal instances for each tooltip button.
 * This function is immediately invoked to set up tooltips when the script loads.
 * 
 * @function
 * @name initializeTooltips
 * @param {void}
 * @returns {void}
 */
(function () {
	"use_strict";
	const tooltips = [...document.querySelectorAll('.tooltip--button')]
	for (let tooltip of tooltips) {
		new Modal(tooltip, content);
	}
}());
